import { Close, DeleteOutline } from "@mui/icons-material";
import { ContainerModal, FooterModal } from "./styles";
import isMobile from "is-mobile";
import { Modal } from "../../modal-base";
import { StyledTypography } from "../../modal-base/modal-header-text/style";

export const ModalDelete = ({
  isOpen,
  toggle,
  action,
  title,
  description,
  isDisabledButton,
}: {
  isOpen: boolean;
  toggle: () => void;
  action: () => Promise<void>;
  title: string;
  description: string;
  isDisabledButton: boolean;
}) => {
  return (
    <Modal.Root open={isOpen} onClose={toggle} maxWidth="450px">
      <Modal.Header>
        <Modal.Icon icon="Close" cursor="pointer" onClick={toggle} />
      </Modal.Header>
      <Modal.Content>
        <ContainerModal>
          <Modal.Icon
            icon="DeleteOutline"
            iconColor="#F92513"
            circular
            circularColor="#FDF3F2"
            circularBorder={true}
            padding="2px"
          />
          <StyledTypography
            ownerState={{
              fontSize: isMobile() ? 18 : 24,
              fontWeight: 700,
              color: "#404252",
            }}
          >
            {title}
          </StyledTypography>
          <StyledTypography
            ownerState={{
              color: "#404252",
            }}
            style={{ textAlign: "center" }}
          >
            {description}
          </StyledTypography>
          <FooterModal>
            <Modal.Button
              bgColor=""
              color="danger"
              onClick={action}
              startIcon={<DeleteOutline />}
              disabled={isDisabledButton}
            >
              Continuar
            </Modal.Button>
            <Modal.Button onClick={toggle} startIcon={<Close />} bgColor="">
              Cancelar
            </Modal.Button>
          </FooterModal>
        </ContainerModal>
      </Modal.Content>
    </Modal.Root>
  );
};
